module.exports = "/images/vendor/flag-icon-css/flags/1x1/za.svg?67ff2e108ce38abcf3f68b4e1ba3c7af";